import Announcement from "@mapmycustomers/shared/types/announcements/Announcement";

// An announcement declares an image when it has a file URL with an image content type.
const getAnnouncementImageUrl = ({
  fileContentType,
  fileUrl,
}: Pick<Announcement, "fileContentType" | "fileUrl">):
  | NonNullable<Announcement["fileUrl"]>
  | undefined => (fileUrl && fileContentType?.startsWith("image/") ? fileUrl : undefined);

export default getAnnouncementImageUrl;
